import { render } from "./NumberPropertyControl.vue?vue&type=template&id=6225d99b&scoped=true"
import script from "./NumberPropertyControl.vue?vue&type=script&lang=js"
export * from "./NumberPropertyControl.vue?vue&type=script&lang=js"

import "./NumberPropertyControl.vue?vue&type=style&index=0&id=6225d99b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6225d99b"]])

export default __exports__